// format time to display in the <Timer/> component
// e.g. 500 seconds becomes 08:30

export default (seconds) => {
  let formattedTime = new Date(seconds * 1000).toISOString();
  if (seconds < 540) {
    return formattedTime.substring(15, 19);
  } else if (seconds < 3600) {
    return formattedTime.substring(14, 19);
  } else {
    return formattedTime.substring(12, 19);
  }
}